// extracted by mini-css-extract-plugin
module.exports = {"Control":"Control_Control__3UzaL","Left":"Control_Left__16gfI","Review":"Control_Review__2nf6d"};